import { useContext } from "react";

import { LLMRateLimitContext } from "../../contexts/user/LLMRateLimitContext";

const useLLMRateLimit = () => {
  const context = useContext(LLMRateLimitContext);
  return context;
};

export default useLLMRateLimit;
